<ion-grid class="ion-no-padding">
    <ion-row>
        <!-- Left col -->
        <ion-col size="5" class="left-col ion-no-padding ion-hide-md-down">
            <div class="left-col__logo"
                 [style.background-image]="sanitizer.bypassSecurityTrustStyle('url(' + settings.largeLogo + ')')"></div>
        </ion-col>

        <!-- Right col -->
        <ion-col class="right-col ion-no-padding">
            <!-- Back button -->
            <div class="vesta-back-navigation" *ngIf="showBackButton">
                <div class="vesta-back-navigation__back"
                     [routerLink]="['/', backButtonLink]"
                     queryParamsHandling="preserve"
                     routerDirection="back">
                    <ion-icon class="header-back__icon--desktop"
                              mode="ios"
                              name="chevron-back"></ion-icon>
                    <ion-text>Back</ion-text>
                </div>
            </div>
            <ion-img class="right-col__logo"
                     src="{{ settings.logo }}"
                     [routerLink]="['/']"
                     queryParamsHandling="preserve"></ion-img>
            <div class="right-col__powered-by">Powered by Vesta</div>

            <div class="right-col__content">
                <ng-content></ng-content>
            </div>
        </ion-col>
    </ion-row>
</ion-grid>
